import { Link, router } from '@inertiajs/react';
import { SessionContext } from '@onwardtravelsolutions/package-react/Contexts';
import { NoticeType } from '@onwardtravelsolutions/package-react/Enums';
import { isAnonymous } from '@onwardtravelsolutions/package-react/Utilities/users';
import { useContext } from 'react';
import { EnvironmentContext } from '../Contexts';
import { Link as LinkType } from '../Types';
import { Session } from '@onwardtravelsolutions/package-react/Types';

type HeaderProps = {
    links?: LinkType[];
};

export default function Header({ links = [] }: HeaderProps) {
    const { user, logOut, addGlobalNotice } = useContext(
        SessionContext,
    ) as Session;
    const { urls } = useContext(EnvironmentContext) as any;
    const menu = [
        ...links,
        ...(user && !isAnonymous(user)
            ? [
                  {
                      href: urls.home,
                      title: 'Log Out',
                      label: 'Log Out',
                      onClick: async (event: any) => {
                          event.preventDefault();
                          await logOut();

                          router.get(
                              urls.login,
                              {},
                              {
                                  preserveState: false,
                              },
                          );
                          addGlobalNotice({
                              title: 'You Are Now Logged Out',
                              body: 'You have been Logged Out of your account.',
                              type: NoticeType.Information,
                              actions: [],
                              uid: 'logged_out',
                              ttl: 3000,
                          });
                      },
                  },
              ]
            : []),
    ];

    return (
        <header className='z-100 fixed bg-[#03090f30] px-3 md:px-5 py-4 lg:py-8 w-full'>
            <div className='relative flex flex-col m-auto max-w-6xl'>
                <div className='flex flex-row justify-between items-center'>
                    <a
                        href='/#home'
                        title='View The Homepage'
                        className='flex items-center'
                    >
                        <img
                            src='/img/ots-logo.svg'
                            alt='Onward Travel Solutions Logo'
                            className='w-10 lg:w-12 h-10 lg:h-12'
                        />
                        <div className='hidden md:inline-block ml-1 font-light text-xl lg:text-2xl uppercase leading-5'>
                            <span className='block text-primary'>
                                Onward Travel
                            </span>
                            <span className='block text-white'>
                                Solutions Ltd
                            </span>
                        </div>
                    </a>
                    <ul className='flex'>
                        {menu.map(({ href, title, label, onClick }, i) => (
                            <li key={`menu-item-${i}`}>
                                <Link
                                    href={href}
                                    title={title}
                                    onClick={onClick}
                                    className='-mr-2 lg:-mr-6 p-2 lg:p-6 font-light text-white hover:text-primary text-sm lg:text-lg uppercase whitespace-nowrap transition'
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </header>
    );
}
